import { apiClient } from './axios';
import { IEmployee } from './employee';
export enum PaymentMethod {
  BANK_TRANSFER = 'BANK_TRANSFER',
  CASH = 'CASH',
  CREDIT = 'CREDIT',
}

export enum supplierStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export interface ISupplier {
  id: number;
  name: string;
  address: string;
  taxCode: string;
  phone: string;
  email: string;
  paymentMethod?: PaymentMethod;
  bankName?: string;
  bankAccountNumber?: string;
  bankAccountHolder?: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  creator: IEmployee;
  status: boolean;
}

export interface SupplierFormData {
  name: string;
  address: string;
  taxCode: string;
  phone: string;
  email: string;
  bankName?: string | null | undefined;
  bankAccountNumber?: string | null | undefined;
  bankAccountHolder?: string | null | undefined;
  paymentMethod?: string | null | undefined;
}
export const getSuppliers = async (
  search: string,
  taxCode: string
): Promise<ISupplier[]> => {
  const response = await apiClient.get<ISupplier[]>('suppliers', {
    params: {
      search,
      taxCode,
    },
  });
  return response.data;
};

export const createSupplier = async (
  supplier: SupplierFormData
): Promise<ISupplier> => {
  const response = await apiClient.post<ISupplier>('suppliers', supplier);
  if (!response.success) {
    throw new Error(response.message);
  }
  return response.data;
};

export const updateSupplier = async (
  id: string,
  supplier: SupplierFormData
): Promise<ISupplier> => {
  const response = await apiClient.patch<ISupplier>(
    `suppliers/${id}`,
    supplier
  );
  if (!response.success) {
    throw new Error(response.message);
  }
  return response.data;
};

export const deleteSupplier = async (id: string) => {
  const response = await apiClient.delete(`suppliers/${id}`);
  if (!response.success && response?.error) {
    throw new Error(response.message);
  }
  return response.data;
};

export const updateSupplierStatus = async (id: number, status: boolean) => {
  const response = await apiClient.patch(`suppliers/${id}/status`, { status });
  if (!response.success) {
    throw new Error(response.message);
  }
  return response.data;
};
